import React from "react";
import { TextField } from "@mui/material";
import RelatedDocs from "../modals/RelatedDocs";
import QuotationDocs from "../modals/QuotationDocs";

const CustomerDetailsTab = ({
  selectedLead,
  subject,
  setCustomerSubject,
  customerTRN,
  setCustomerTRN,
  setCustomerAddress,
  setAttentionInQuotation,
  attentionInQuotation,
  customerAddress,
  quotationNumberOfThisLead,
}) => {
  console.log(
    "selectedLead from customer Details:",
    selectedLead,
    customerAddress
  );

  const handleTRNChange = (event) => {
    setCustomerTRN(event.target.value);
  };
  const handleSubjectChange = (event) => {
    setCustomerSubject(event.target.value); // Update the TRN value based on user input
  };

  return (
    <div>
      <div className="grid grid-cols-5 gap-4 mb-4">
        {/* <TextField
        label="Lead ID"
        size="small"
        variant="standard"
        value={selectedLead?.lead_id}
      /> */}
        {/* <p> Lead {selectedLead?.lead_id}</p> */}
        <TextField
          label="Attention Person Info"
          size="small"
          variant="standard"
          value={attentionInQuotation}
          onChange={(e) => setAttentionInQuotation(e.target.value)}
        />
        <TextField
          label="Customer Reference Number"
          value=""
          size="small"
          variant="standard"
        />
        <TextField
          label="Subject"
          size="small"
          variant="standard"
          value={subject}
          onChange={handleSubjectChange}
        />
        <TextField
          label="TRN"
          value={customerTRN}
          size="small"
          variant="standard"
          onChange={handleTRNChange}
        />
      </div>

      <div className="flex justify-between items-center gap-4">
        <TextField
        placeholder="Please Enter Address,Email,Phone etc here"
          label="Organization Address"
          value={
            quotationNumberOfThisLead
              ? customerAddress
              : selectedLead?.lead_id
              ? [
                  selectedLead?.lead_appartment,
                  selectedLead?.lead_streetaddress,
                  selectedLead?.lead_city,
                  selectedLead?.lead_area,
                  selectedLead?.lead_location,
                  selectedLead?.lead_territory,
                  selectedLead?.lead_country,
                  selectedLead?.lead_email,
                  selectedLead?.lead_phone
                    ? "phone : " + selectedLead?.lead_phone
                    : "",
                ]
                  .filter((field) => field && field.trim() !== "")
                  .join(", ") || ""
              : customerAddress
          }
          size="x-large"
          fullWidth
          multiline
          variant="standard"
          InputProps={{
            style: { fontSize: "1rem" },
          }}
          onChange={(e) => setCustomerAddress(e.target.value)}
        />

        <div className="flex justify-center items-center gap-6">
          <RelatedDocs />
          <QuotationDocs />
        </div>
      </div>
    </div>
  );
};

export default CustomerDetailsTab;
